module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/social/twitter-ede1e444ccf3ef929e971d0d7904443e.svg";